import React from 'react'
import PropTypes from 'prop-types'

const PaymentInstructions = ({ paymentType, onGeneratePaynowQr, isGeneratingQr }) => {
    return (
        <>
            <p>
                <b className="text-danger">DO NOT close this screen.</b>
            </p>
            <>
                <b className="text-danger text-center">Your order will only be confirmed after payment.</b>
                <br />
                <b className="text-dark m-0 text-center" style={{ fontSize: '1.1rem', fontWeight: 'bold', textAlign: 'center' }}>
                    Proceed to the Drink Stall Cashier
                </b>
                <p className="text-dark m-0 text-center">
                    with your Order Number for payment. (Cash or Paynow QR Scanning method)
                </p>
            </>
            <br />
            <div>
                <p className="text-dark m-0">Beat the queue now!</p>
                <p className="text-dark text-center m-0">
                    Click Generate Paynow QR below and upload screenshot to your banking app.
                </p>
                <button
                    className="btn text-white my-3 d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: paymentType === 'PAYNOW' ? '#ccc' : '#9e278e', width: '100%' }}
                    onClick={onGeneratePaynowQr}
                    disabled={isGeneratingQr || paymentType === 'PAYNOW'}
                >
                    {isGeneratingQr ?
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Generating...
                        </>
                    :   'Generate Paynow QR Code'}
                </button>
            </div>
            <p>
                Once it's paid, please click the button below to check your order status.{' '}
                <b className="text-danger">Self-collect</b> your food at the respective stall(s) when they are ready.
            </p>
        </>
    )
}

PaymentInstructions.propTypes = {
    paymentType: PropTypes.string,
    onGeneratePaynowQr: PropTypes.func,
    isGeneratingQr: PropTypes.bool,
}

export default PaymentInstructions
